import { Component, computed, inject, Signal } from '@angular/core';
import { IWizardModel } from '@mwe/models';
import {
  ROUTE_AGENT_SELECTION,
  ROUTE_COMPANY_CHECK,
  ROUTE_COMPANY_SELECT,
  ROUTE_CUSTOMER_REGISTRATION,
  ROUTE_HOME,
  ROUTE_INVITE,
  ROUTE_THANK_YOU,
} from '../../app.constants';
import { NavigationStateService } from '@mwe/services';
import { CustomerRegistrationService } from '../../service/customer-registration/customer-registration.service';
import { UiComponentsModule } from '@mwe/ui/components';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'ikp-berater-registration',
  templateUrl: './registration.component.html',
  imports: [UiComponentsModule, RouterOutlet],
})
export class RegistrationComponent {
  private readonly navigationStateService = inject(NavigationStateService);
  NEXT_BUTTON_LABEL = 'global.continue';
  PREV_BUTTON_LABEL = 'global.back';
  registrationService = inject(CustomerRegistrationService);

  wizardModel: Signal<IWizardModel> = computed(() => ({
    titleKey: 'global.registration.titleHeader',
    isDeepLinkEnabled: true,
    forwardDirectionChangeIx: 0,
    hideProgressBar: false,
    useMoreWidth: true,
    wizardSteps: [
      {
        titleKey: 'global.registration.company-select.title',
        path: getRoute(ROUTE_COMPANY_SELECT),
        nextButtonLabel: this.NEXT_BUTTON_LABEL,
        prevButtonLabel: this.PREV_BUTTON_LABEL,
        nextButtonDisabled: this.registrationService.isNextButtonDisabled$,
        progressBarLabel: 'global.registration.company-select.progressBarLabel',
      },
      {
        titleKey: 'global.registration.company-check.title',
        path: getRoute(ROUTE_COMPANY_CHECK),
        nextButtonLabel: this.NEXT_BUTTON_LABEL,
        prevButtonLabel: this.PREV_BUTTON_LABEL,
        progressBarLabel: 'global.registration.company-check.progressBarLabel',
      },
      {
        path: getRoute(ROUTE_AGENT_SELECTION),
        nextButtonLabel: this.NEXT_BUTTON_LABEL,
        prevButtonLabel: this.PREV_BUTTON_LABEL,
        nextButtonDisabled: this.registrationService.isNextButtonDisabled$,
        progressBarLabel: 'global.registration.agent-selection.progressBarLabel',
      },
      {
        path: getRoute(ROUTE_INVITE),
        nextButtonLabel: 'global.registration.invite.nextButtonLabel',
        prevButtonLabel: this.PREV_BUTTON_LABEL,
        progressBarLabel: 'global.registration.invite.progressBarLabel',
      },
      {
        path: getRoute(ROUTE_THANK_YOU),
        hidePrevButton: true,
        showCancelWarning: false,
        progressBarLabel: 'global.registration.thankyou.progressBarLabel',
      },
    ],
  }));

  constructor() {
    this.navigationStateService.wizardCancelUrl = ROUTE_HOME;
    this.navigationStateService.wizardSuccessUrl = ROUTE_HOME;
  }
}

export function getRoute(childRoute: string): string {
  return `/${ROUTE_CUSTOMER_REGISTRATION}/${childRoute}`;
}
